import React from 'react';

import { Icon, Spin } from 'antd';

const Spinner = (props) => (
  <Spin indicator={<Icon type="loading" />} {...props} />
);

export default Spinner;
